import React from "react";
import { Divider } from "@mui/material";
import ValueSkeleton from "components/ValueSkeleton";
import { FEATURE_FLAGS } from "utils/firebaseFeatureFlags";
import { useFirebaseFeatureFlag } from "hooks/useFirebaseFeatureFlag";
import { getAssetUrl, openExternalLinkInNewTab } from "utils/common";
import WishlinkTypography from "WishlinkComponents/WishlinkTypography";

const UnderMaintenance = () => {
  const { flagValue, isLoading } = useFirebaseFeatureFlag(
    FEATURE_FLAGS.APP_UNDER_MAINTENANCE_PLACEHOLDER
  );
  let parsedData = null;
  try {
    parsedData = flagValue ? JSON.parse(flagValue) : null;
  } catch (error) {
    console.error("Error parsing maintenance placeholder JSON:", error);
  }
  const placeholderText = parsedData?.tittle;
  const notes = parsedData?.notes || [];

  return (
    <div className="App" style={{ minHeight: window.innerHeight }}>
      <div
        className="flex"
        style={{
          flexDirection: "column",
          padding: "1.25rem",
          height: "100vh",
        }}
      >
        <img
          src={getAssetUrl("wishlink-logo.svg")}
          style={{
            width: "6.5rem",
            height: "1.5rem",
          }}
          alt="wishlink-logo"
        />
        <div
          className="flex"
          style={{
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={getAssetUrl("under-maintenance-logo.svg")}
            style={{
              width: "9.6875rem",
              height: "7.8125rem",
            }}
            alt="wishlink-logo"
          />
          <WishlinkTypography
            fontSize="1.25rem"
            fontWeight={600}
            textAlign={"center"}
            mt="2.25rem"
          >
            We’re down for maintenance!
          </WishlinkTypography>
          <WishlinkTypography
            fontSize="0.75rem"
            fontWeight={500}
            textAlign={"center"}
          >
            But don't worry, your earnings are still being tracked on Wishlink!
          </WishlinkTypography>
          <div style={{ marginTop: "1rem" }}>
            <img
              src={getAssetUrl("under-maintenance-clock.svg")}
              style={{
                width: "2rem",
                height: "2rem",
              }}
              alt="under-maintenance-clock"
            />
            {placeholderText && (
              <WishlinkTypography
                fontSize="0.75rem"
                fontWeight={400}
                textAlign={"center"}
                mt="0.5rem"
              >
                <b>
                  <ValueSkeleton
                    width="100%"
                    isLoading={isLoading}
                    value={placeholderText}
                  />
                </b>
              </WishlinkTypography>
            )}
            <WishlinkTypography
              fontSize="0.75rem"
              fontWeight={400}
              textAlign={"center"}
              color="#00000080"
              mt="0.5rem"
              mb="0rem"
            >
              For any queries reach out to us at :
            </WishlinkTypography>
            <WishlinkTypography
              onClick={() => {
                openExternalLinkInNewTab({
                  redirectUrl: "mailto:creator.connect@wishlink.com",
                });
              }}
              fontSize="0.625rem"
              fontWeight={600}
              textAlign={"center"}
              color="#144cc7"
              mt="0rem"
              mb="0.75rem"
            >
              <u>creator.connect@wishlink.com</u>
            </WishlinkTypography>
            <Divider />
          </div>
          {notes?.length > 0 && (
            <div style={{ width: "100%" }}>
              <WishlinkTypography
                fontSize="0.75rem"
                fontWeight={500}
                textAlign={"left"}
                mt="2.5rem"
                lineHeight="0.9375rem"
                typographystyle={{ width: "100%" }}
              >
                Few points to note, during this period:
              </WishlinkTypography>
              <WishlinkTypography
                fontSize="0.75rem"
                fontWeight={500}
                fontStyle="normal"
                textAlign="left"
                mt="0.75rem"
                lineHeight="0.9375rem"
              >
                {notes?.map((line, index) => (
                  <React.Fragment key={index}>
                    • {line}
                    <br />
                  </React.Fragment>
                ))}
              </WishlinkTypography>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default UnderMaintenance;
